import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Main from './pages/Main';
import Leads from './pages/leads/Leads';
import Patients from './pages/patients/Patients';
import Register from './pages/register/Register';
import Login from './pages/login/Login';
import Calendar from './pages/calendar/Calendar';
import BookingView from './pages/booking-view/BookingView';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastProvider } from './pages/toast/ToastProvider';
import { AuthProvider } from './pages/authentication/AuthContext';
import ProtectedRoute from './pages/authentication/ProtectedRoute';
import BookingPreferences from './pages/booking-preferences/BookingPreferences';
import Booking from './pages/booking/Booking';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ForgotPassword from './pages/forgot-password/ForgotPassword';
import ResetPassword from './pages/reset-password/ResetPassword';

function App() {

const { i18n } = useTranslation();
const isRtl = i18n.language === 'he';

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === 'he' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <AuthProvider>
      <ToastProvider>
        <div className="App">
          <Router>
            <Routes>
              {/* Public Routes */}
              <Route path="register" element={<Register />} />
              <Route path="/:lang/register" element={<Register />} />
              <Route path="login" element={<Login />} />
              <Route path="/:lang/login" element={<Login />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="reset-password/:token" element={<ResetPassword />} />
              <Route path="/booking/:guid" element={<Booking />} />
              <Route path="/:lang/booking/:guid" element={<Booking />} />

              {/* Protected Routes */}
              <Route path="/" element={<ProtectedRoute />}>
                <Route path="/" element={<Main />}>
                  {/* <Route index element={<h1>Welcome to the Main Page</h1>} /> */}
                  <Route path="leads" element={<Leads />} />
                  <Route path="patients" element={<Patients />} />
                  <Route path="calendar" element={<Calendar />} />
                  <Route path="booking" element={<BookingView />} />
                  <Route path="preferences" element={<BookingPreferences />} />
                </Route>
              </Route>
            </Routes>
          </Router>

          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={true}
            closeButton={true}
            rtl={isRtl} 
          />
        </div>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;


/*
 
 check if there is better practice for remmber me
 check option to keep jwt access token in HTTP-Only Cookies

 Validate it possible to add or update an exist patient email in another company
 
 Add switch clinic in client against server - router.post('/switch-clinic', switchClinic);

backend health check:
https://crm-api-79kt.onrender.com/users/health

SMS
web socket



handle error response from whats app api

lead messages - handle display messages according the code response from the translation

multiple clinic in company
	
IAM user name: softnet-crm-app-user	
SMTP user name: AKIAQFUA7BWNLJK4QH5E	
SMTP password: BGZECOVZum3mN2EG91WLoFXoxqCtju6SjE8lAvrF/LEs

SMTP endpoint
email-smtp.us-east-1.amazonaws.com

normalizeIsraeliPhoneNumber - create generic function to handle US etc. // add option to select country when set a phone number (registration, patients etc.)

register should return error with code as in patient 
"Email already exists" message for example not shown in client

Make scroll hide in tabs: calandar, booking preferences - it's make jumpy when switch between tabs
*/